module.exports = __webpack_public_path__ + "static/hardware3-61553867678a3db4ae1acd2767d06321.jpg";